const suppliersData = [
    {
        id:"1",
        image:require("../../assets/suppliers/1 (1).png")
    },
    {
        id:"2",
        image:require("../../assets/suppliers/1 (2).png")
    },
    {
        id:"3",
        image:require("../../assets/suppliers/1 (3).png")
    },
    {
        id:"4",
        image:require("../../assets/suppliers/1 (4).png")
    },
    {
        id:"5",
        image:require("../../assets/suppliers/1 (5).png")
    },
    {
        id:"6",
        image:require("../../assets/suppliers/1 (6).png")
    },
    {
        id:"7",
        image:require("../../assets/suppliers/1 (7).png")
    },
    {
        id:"8",
        image:require("../../assets/suppliers/1 (8).png")
    },
    {
        id:"9",
        image:require("../../assets/suppliers/1 (9).png")
    },

]

export default suppliersData;